import React, { useState, useEffect } from 'react';
import './TutorAsignado.css';
import { motion, AnimatePresence } from 'framer-motion';
import { FaUserGraduate, FaTimes } from 'react-icons/fa';

const TutorAsignado = ({ nombres, correo, telefono }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => setIsOpen(!isOpen);
  const closeModal = () => setIsOpen(false);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') {
        closeModal();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  return (
    <div>
      <motion.button
        className="tutor-btn"
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.95 }}
        onClick={toggleModal}
      >
        <FaUserGraduate size={32} className="icon" />
      </motion.button>

 
        {isOpen && (
          <motion.div 
            className="modal-backdrop" 
            initial={{ opacity: 0 }} 
            animate={{ opacity: 1 }} 
            exit={{ opacity: 0 }}
            onClick={closeModal}
          >
            <motion.div 
              className="modal-content" 
              initial={{ scale: 0.8 }} 
              animate={{ scale: 1 }} 
              exit={{ scale: 0.8 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="close-button" onClick={closeModal}>
                <FaTimes />
              </button>
              <div className="tabla-container verde">
                <h3 className="titulo-tabla">Tutor Asignado</h3>
                <table className="tabla-tutor">
                  <tbody>
                    <tr>
                      <th>Nombres Completos</th>
                      <td>{nombres}</td>
                    </tr>
                    <tr>
                      <th>Correo Institucional</th>
                      <td>{correo}</td>
                    </tr>
                    <tr>
                      <th>Teléfono</th>
                      <td>{telefono}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </motion.div>
          </motion.div>
        )}
  
    </div>
  );
};

export default TutorAsignado;
